const options = {
  5: "bg-amber-800/5",
  10: "bg-amber-800/10",
  25: "bg-amber-800/25",
  50: "bg-amber-800/50",
  75: "bg-amber-800/75",
  90: "bg-amber-800/90",
  100: "bg-amber-800",
};

const from = {
  5: "from-amber-800/5",
  10: "from-amber-800/10",
  25: "from-amber-800/25",
  50: "from-amber-800/50",
  75: "from-amber-800/75",
  90: "from-amber-800/90",
  100: "from-amber-800",
};

export default function getBackgroundAmber800(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
